<template>
  <div class="app-menu-home">
    <div
      v-for="item in menuList"
      :key="item.path"
      class="app-menu-home__item"
      @click="onClick(item)"
    >
      {{ $t(`app.menu.${item.name}`) }} <span class="new" v-if="item.name === 'datasub'">NEW</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { IS_PRODUCT_HOST } from '@/utils'
import { generateSid } from '@/services/auth'
// import { useState } from '@/hooks/useVuex'

// const { tiToken } = useState('user', ['tiToken'])

const router = useRouter()
const store = useStore()
const isProduct = IS_PRODUCT_HOST

const menuList = computed(() => {
  // const tiPath = tiToken.value ? `https://ti.360.net/#/homepage?sign=${tiToken.value}&from=ata` : 'https://ti.360.net/#/homepage'
  const arr = [
    {
      path: '/detect',
      name: 'submit'
    },
    {
      path: '/taskhub',
      name: 'task'
    },
    // {
    //   path: '/hunting',
    //   name: 'hunting'
    // },
    {
      path: '/datasub',
      name: 'datasub'
    },
    {
      path: '/help',
      name: 'help'
    },
    {
      path: '/price',
      name: 'upgrade'
    },
    // {
    //   path: tiPath,
    //   name: 'ti',
    //   type: 'open'
    // },
    {
      path: '/screen/',
      name: 'trends',
      type: 'open'
    },
    {
      path: '/tracked',
      name: 'track'
    },
    {
      path: '/skillsguard/',
      related: 'skillsguard',
      name: 'clawSkills',
      type: 'open'
    },
    {
      name: 'agent',
      action: 'agent',
      ref: `${window.location.origin}/automaton/auth/ata`
    }
  ]
  return !isProduct ? arr : arr.filter(item => item.path !== '/datasub' && item.action !== 'agent')
})

// const menuList = ref([
//   {
//     path: '/detect',
//     name: 'submit'
//   },
//   {
//     path: '/taskhub',
//     name: 'task'
//   },
//   {
//     path: '/help',
//     name: 'help'
//   },
//   {
//     path: '/price',
//     name: 'upgrade'
//   },
//   {
//     path: 'https://ti.360.net',
//     name: 'ti',
//     type: 'open'
//   },
//   {
//     path: 'https://ata.360.net/screen/',
//     name: 'trends',
//     type: 'open'
//   },
//   {
//     path: '/tracked',
//     name: 'track'
//   }
// ])

const onClick = (item) => {
  if (item.action === 'agent') {
    // 未登录：直接跳转到智能体页面，让用户自行登录
    if (!store.getters.isLogin) {
      window.open(`${window.location.origin}/automaton/`, '_blank')
      return
    }
    // 已登录：生成 SID 并跳转到智能体页面
    generateSid({
      app: 'ata-agent',
      ref: item.ref
    }).then((res) => {
      const sid = typeof res === 'object' ? (res.sid || res.data || res) : res
      if (sid) {
        const redirectUrl = `${item.ref}${item.ref.includes('?') ? '&' : '?'}sid=${sid}`
        window.open(redirectUrl, '_blank')
      }
    })
    return
  }
  if (item.type === 'open') {
    window.open(item.path, '_blank')
  } else {
    router.push(item.path)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.app-menu-home {
  height: $header-height;
  display: flex;
  align-items: center;
  &__item {
    position: relative;
    display: inline-block;
    // width: 104px;
    padding: 0 18px;
    height: $header-height;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-text-1);
    cursor: pointer;
    &:hover {
      color: var(--color-primary);
    }
  }
  .new {
    background: linear-gradient(90deg, #FF4646 4%, #FF7C62 100%);
    border-radius: 4px;
    font-size: 8px;
    font-weight: 500;
    color: #FFFFFF;
    padding: 2px 4px;
    margin-left: 4px;
  }
}
@media screen and (max-width: 1500px) {
  .app-menu-home {
    &__item {
      padding: 22px 13px;
    }
  }
}
</style>
